import React, { useCallback, useEffect, useState, useContext, useReducer, useMemo } from 'react';
import 'antd/dist/antd.css';
import { Button, Card, Form, Input, message, UploadProps, Tabs } from 'antd';
import '../chatComponent/chat.css';
import {
  getChat,
  sendMessage,
  getSessionPersonal,
  getChatPersonal,
  ReadChatMessages,
  sendMessagePersonal,
  getRefreshTokin,
  getUsersForChat,
} from '../api/api';
import {
  // ContextApp,
  // ContextLastMessage,
  groupChatReducer,
  initialState,
  initialUsersInGroupChatData,
  MessagesAllChatReducer,
  usersInGroupChatReducer,
} from '../../context/Data/ReducerData';

import PersonalChatCards from './PersonalChatCards';
import GroupChatCards from './GroupChatCard';
import ChatMessages from './ChatMessages';
import CreatePersonalGroupChatModal from './CreatePersonalGroupChatModal';
import GroupSettings from './GroupSettings';

const { TextArea } = Input;
const { TabPane } = Tabs;
// Для счетчика отправленных мной сообщений
let idOfsendMessage = 0;

const MainBlockChat = ({ messageFromSocket }: any) => {
  const [form] = Form.useForm();

  //id - сессии, user_id - пользователь
  const [sessionNumber, setSessionNumber] = useState<{
    id: any;
    user_id: any;
    is_group: any;
    session_id: any;
  }>({
    id: null,
    user_id: null,
    is_group: null,
    session_id: null,
  });
  //для отрисовки сообщений по чату
  const [chat, setChat] = useState<
    { id: any; content: any; sender_name: any; receiver_id: any; send_timestamp: any; send: any }[]
  >([]);
  //хранит сообщения по чату
  // const { state, dispatch } = useContext(ContextApp);
  const [state, dispatch] = useReducer(MessagesAllChatReducer, initialState);

  //хранит написанные в чатах сообщения, которые не отправлены
  // const { lastMessage, dispatchLastMessage } = useContext(ContextLastMessage);

  //для перезапуска useeffect
  const [reset, setReset] = useState(false);
  //id прошлой сессии
  const [previousSessionId, setPreviousSessionId] = useState(0);
  //id нынешней сессии
  const [newMessage, setNewMessage] = useState<{
    id: any;
    user_id: any;
    content: any;
    sender_name: any;
    receiver_id: any;
    send_timestamp: any;
    send: any;
  }>({
    id: null,
    content: null,
    user_id: null,
    sender_name: null,
    receiver_id: null,
    send_timestamp: null,
    send: null,
  });
  //Пользователь не в группе
  const [usersNotInGroup, setUsersNotInGroup] = useState([]);
  //Данные для создания группы
  const [groupCreateData, groupCreateDataDispatch] = useReducer(groupChatReducer, {
    group_name: null,
    user_id: [],
  });
  //Хранилище пользователей которые находятся в том или ином чате
  const [usersInGroupChatData, usersInGroupChatDataDispatch] = useReducer(
    usersInGroupChatReducer,
    initialUsersInGroupChatData
  );
  //Данные для вывода людей состоящих в том или ином чате
  const [usersInGroupChat, setUsersInGroupChat] = useState<[{ user_id: any }]>([{ user_id: null }]);
  // все сессии групповые
  const [sessionGroup, setSessionGroup] = useState([]);
  // все сессии персональные
  const [sessionPersonal, setSessionPersonal] = useState<
    { receiver_id: any; user_id: any; receiver_name: any; unread_msg: any }[]
  >([]);
  const [nameFriend, setNameFriend] = useState();
  // все пользователи
  const [allUsers, setAllUsers] = useState([]);

  const catchError = () => {
    return getRefreshTokin()
      .then((res: any) => res.json())
      .then((res: any) => {
        localStorage.access_token = res.access_token;
      })
      .catch(() => {
        localStorage.removeItem('access_token');
      });
  };
  // Для рефреша useEffect с карточками и пользователями
  const resetUseEffect = () => {
    reset ? setReset(false) : setReset(true);
  };
  const getSessionPersonalFunc = () => {
    getSessionPersonal()
      .then((res) => {
        if (res.message) {
          catchError().then(() => {
            getSessionPersonalFunc();
          });
        } else {
          // console.log('getSessionPersonal', res);
          getUsersForChat().then((res: any) => {
            // console.log('getUsersForChat', res);
            // getSessions().then((res) => {
            //   // console.log('getSessionGroup', res);
            //   setSessionGroup(res.data);
            // });
            setAllUsers(res);
          });

          setSessionPersonal(res.data);
        }
      })
      .catch(() => {
        // alert('Перезагрузите страницу!');
        resetUseEffect();
      });
  };

  //Для подгрузки карточек личного, группового
  useEffect(() => {
    getSessionPersonalFunc();
  }, [reset]);
  /////////////////////////////////////////////

  /////////////////////////////////////

  //Очищает state группового чата и закрывает модалку
  const resetStateFromModalGroup = () => {
    groupCreateDataDispatch({ type: 'resetGroupChatState' });
  };

  //Для изменения названия имени окна чата
  const setNameFriendFunc = (name: any) => {
    setNameFriend(name);
  };
  ////////////////////////////////////////

  const props: UploadProps = {
    name: 'file',
    // походу сюда наш бэк надо
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  //2 функции для открытия чата и записи
  //состояния группового и личного чата
  // const openGroup = (obj: any) => {
  //   setSessionNumber(obj);
  //   addChatMessages(obj);
  //   readChatMessagesFunc(obj);
  //   setPreviousSessionId(obj.session_id);
  // };
  ////////////////////////////////
  const getChatPersonalFunc = (obj: any) => {
    getChatPersonal(obj.session_id).then((res) => {
      if (res.message) {
        catchError().then((res: any) => {
          getChatPersonalFunc(obj);
        });
      } else {
        res.session_id = obj.session_id;
        dispatch({ type: 'setAllChat', res });
        setChat((chat) => res.data);
      }

      // document.getElementsByClassName('wrapper__massege')[0].scrollTop = 99999;
    });
  };
  //Загрузить все сообщения сессии
  const addChatMessages = (obj: any) => {
    let checkMessageStorage: any = null;
    if (obj.is_group) {
      // console.log('Группа', usersInGroupChatData);
      // В РАЗРАБОТКЕ####################################################
      // checkMessageStorage = state.find(
      //   (item: any) => item.session_id === obj.session_id && item.is_group
      // );
      // const CheckUsersInGroup: any = usersInGroupChatData.find(
      //   (item: any) => item.group_id === obj.session_id
      // );
      // if (CheckUsersInGroup) {
      //   setUsersInGroupChat(CheckUsersInGroup.data);
      // } else {
      //   getUsersInGroup(obj.session_id).then((res) => {
      //     //console.log('getUsersInGroup', res);
      //     res.group_id = obj.session_id;
      //     usersInGroupChatDataDispatch({ type: 'setUsersInGroup', res });
      //     setUsersInGroupChat(res.data);
      //   });
      // }
      //###################################################################
    } else {
      checkMessageStorage = state.find(
        (item: any) => item.session_id === obj.session_id && !item.is_group
      );
    }

    if (checkMessageStorage) {
      setChat((chat) => checkMessageStorage.data);
    } else {
      if (obj.is_group) {
        getChat(obj.session_id).then((res) => {
          res.is_group = true;
          res.session_id = obj.session_id;
          dispatch({ type: 'setAllChat', res });

          setChat(res.data);
        });
      } else {
        // getChatPersonal(obj.session_id).then((res) => {
        //   res.session_id = obj.session_id;
        //   dispatch({ type: 'setAllChat', res });
        //   setChat((chat) => res.data);
        //   // document.getElementsByClassName('wrapper__massege')[0].scrollTop = 99999;
        // });
        getChatPersonalFunc(obj);
      }
    }
  };
  //Добавляем мое сообщение в state
  const addMyMessage = (myMessage: any) => {
    dispatch({
      type: 'setMyMessage',
      data: myMessage,
    });
    setChat((chat) => [...chat, myMessage]);
  };
  const sendMessagePersonalFunc = (myMessage: any, messageData: any) => {
    sendMessagePersonal(messageData)
      .then((res) => {
        addMyMessage(myMessage);
      })
      .catch(() => {
        myMessage.send = 'err';
        addMyMessage(myMessage);
        catchError();
      });
  };
  //В РАЗРАБОТКЕ ###############################
  // Чтение сообщений чата
  const readChatMessagesFunc = (obj: any) => {
    const findPersonalCard: any = sessionPersonal.find(
      (i: any) => i.receiver_id === obj.session_id
    );
    if (findPersonalCard.unread_msg) {
      ReadChatMessages({ receiver_id: obj.session_id, is_group: 0 }).then((res) => {
        findPersonalCard.unread_msg = 0;
        const copySessionPersonal: any = Object.assign([], sessionPersonal);
        setSessionPersonal((sessionPersonal) => copySessionPersonal);
      });
    }
  };
  const openPersonal = (obj: any) => {
    if (obj.session_id !== previousSessionId) {
      setSessionNumber(obj);
      addChatMessages(obj);
      readChatMessagesFunc(obj);
      setPreviousSessionId(obj.session_id);
      form.resetFields();
    }
  };
  ////////////////////////////////////////

  // useEffect(() => {
  //   setSessionPersonal((sessionPersonal) => sessionPersonal);
  //   // sessionPersonal;
  // }, [sessionPersonal]);
  //############################################

  const onFinishFailed = (e: any) => {
    console.log('err', e);
  };

  //Отправка сообщения по Api
  const onFinish = (e: any) => {
    const messageData = e.getFieldsValue();
    if (messageData.content.length >= 1500) return;
    if (messageData.content !== undefined || messageData.document !== undefined) {
      if (messageData.document === undefined) delete messageData.document;
      if (sessionNumber.is_group) {
        messageData.to_user = sessionNumber.user_id;
        sessionNumber.session_id
          ? sendMessage(sessionNumber.session_id, messageData).then((res) => {
              //console.log(res);
            })
          : alert('Выберите нужный чат');
      } else {
        messageData.receiver_id = sessionNumber.session_id;
        idOfsendMessage++;
        const myMessage = {
          id: 'sendMessage' + idOfsendMessage,
          content: messageData.content,
          sender_name: 'Я',
          receiver_id: messageData.receiver_id,
          send_timestamp: new Date().getTime() / 1000,
          send: '',
        };
        sendMessagePersonalFunc(myMessage, messageData);
      }

      form.resetFields();
    }
    ///////////////////////////
  };
  /////////////////////////////////

  //заполняет массив с пользователями, с которыми хотите создать беседу
  const usersArrayFunc = (user_id: any, checked: any) => {
    const user = user_id;
    if (checked) {
      groupCreateDataDispatch({ type: 'setUserFromGroup', user });
    } else {
      groupCreateDataDispatch({ type: 'deleteUserFromGroup', user });
    }
  };
  //////////////////////////////////////////////////////////////////////

  //Функция срабатывает когда нажимаешь на табы
  const chatSettings = (e: any) => {
    switch (e) {
      case 'Chat':
        break;
      case 'Settings':
        break;
      default:
        break;
    }
  };
  //////////////////////////////////////////////

  //Для того чтобы случашь личные чаты
  const propsTakeFromRenderBlock = useMemo(() => {
    // console.log('Websocket сработал', messageFromSocket);
    if (messageFromSocket !== undefined) {
      setNewMessage(messageFromSocket);
    }
  }, [messageFromSocket]);
  /////////////////////////////////////
  /////////////////////////////////////////////////////////
  const sortArrPersonalChat = (cardOnTop: any) => {
    // const cardOnTop: any = Object.assign([], sessionPersonal);
    let newData: any = [];
    for (let i = 0; i != cardOnTop.length; i++) {
      if (newMessage.receiver_id === cardOnTop[i].receiver_id) {
        // console.log(cardOnTop[i]);
        newData = [...cardOnTop.slice(i), ...cardOnTop.slice(0, i)];
        break;
      }
    }
    setSessionPersonal((sessionPersonal) => newData);
  };
  //Для добавления в state нового сообщения личного чата
  //и вывода нового сообщения на экран
  const addWebsocketMessage = useCallback(() => {
    if (newMessage.receiver_id !== null) {
      const findPersonalCard = sessionPersonal.find(
        (i) => newMessage.receiver_id === i.receiver_id
      );
      //Условие если не находим карточку, то добавляем ее в state
      if (findPersonalCard) {
        const checkSessionInState: any = state.find(
          (i: any) => i.session_id === newMessage.receiver_id
        );
        //Если данная сессия подгружена из API
        //то дополняем новыми сообщениями
        if (checkSessionInState) {
          dispatch({
            type: 'setNewMessage',
            data: { session_id: sessionNumber.session_id, message: newMessage },
          });
        } else {
          // console.log('Нет state такого');
        }
        /////////////////////////////////////

        //Отрисовка нового сообщения, если находимся в этой сессии
        if (newMessage.receiver_id === sessionNumber.session_id) {
          setChat([...chat, newMessage]);
        } else {
          findPersonalCard.unread_msg = findPersonalCard.unread_msg + 1;
          const copySessionPersonal: any = Object.assign([], sessionPersonal);
          // Если у карточки новое сообщение, то поднимем ее наверх
          if (sessionPersonal[0].receiver_id !== newMessage.receiver_id) {
            sortArrPersonalChat(copySessionPersonal);
          } else {
            setSessionPersonal((sessionPersonal) => copySessionPersonal);
          }
        }

        //////////////////////////////////////////////////////////
      } else {
        setSessionPersonal((sessionPersonal) => [
          ...sessionPersonal,
          {
            receiver_id: newMessage.receiver_id,
            user_id: newMessage.user_id,
            receiver_name: newMessage.sender_name,
            unread_msg: 1,
          },
        ]);
      }
    }
  }, [newMessage]);
  useEffect(() => {
    addWebsocketMessage();
  }, [addWebsocketMessage]);
  return (
    <>
      <div className="Wrapper_chat">
        {/* Список Чатов */}
        <div className="chat__item">
          {/* Подключаем Кнопки и 2 модального окна для создания чатов */}
          <CreatePersonalGroupChatModal
            props={{
              sessionPersonal: sessionPersonal,
              openPersonal: openPersonal,
              usersArrayFunc: usersArrayFunc,
              groupCreateData: groupCreateData,
              resetStateFromModalGroup: resetStateFromModalGroup,
              resetUseEffect: resetUseEffect,
              allUsers: allUsers,
            }}
          />
          {/* ........................................................ */}

          {/* Подключаем для вывода карточек личного чата */}
          <PersonalChatCards
            props={{
              sessionPersonal: sessionPersonal,
              openPersonal: openPersonal,
              setNameFriendFunc: setNameFriendFunc,
            }}
          />
          {/* ........................................... */}

          {/* Подключаем для вывода карточек группового чата */}
          {/* <GroupChatCards
            props={{
              setNameFriendFunc: setNameFriendFunc,
              sessionGroup: sessionGroup,
              openPersonal: openPersonal,
            }}
          /> */}
          {/* .............................................. */}
        </div>
        {/* Окно с Чатом и Настройками */}
        <div className="chat__massege">
          <Tabs onTabClick={chatSettings} type="card">
            <Tabs.TabPane tab="Чат" key="Chat" className="chat__massege--container">
              {/* <div className="chat__message--title">{nameFriend}</div> */}
              {/* Подключаем вывод сообщений того или иного чата */}
              <ChatMessages
                props={{
                  Messages: chat,
                  sessionIds: sessionNumber,
                  allChatMessages: state,
                  catchError: catchError,
                }}
              />

              {/* .............................................. */}
              {chat.length ? (
                <div className="massage__wraper-form">
                  <div className="massage__from--input">
                    <Form
                      form={form}
                      name="sendMessage"
                      onFinish={form.submit}
                      onFinishFailed={onFinishFailed}
                    >
                      <Form.Item
                        rules={[
                          {
                            max: 1500,
                            message: 'Превышено максимальное кол-во символов( 1500 )',
                          },
                        ]}
                        name="content"
                      >
                        {/* ПЕРЕНОС СТРОКИ CTRL + ENTER */}

                        <div className="chat-input__container">
                          <TextArea
                            className="chat-input__area"
                            placeholder="Напишите что нибудь..."
                            rows={2}
                            style={{ marginBottom: 0 }}
                            onPressEnter={() => onFinish(form)}
                            autoSize={{ minRows: 1, maxRows: 1 }}
                          />
                        </div>
                      </Form.Item>
                      <div style={{ display: 'flex' }}>
                        {/* <Form.Item style={{ marginRight: 20 }}>
                        <Button htmlType="submit">Отправить</Button>
                      </Form.Item> */}
                        {/* <Form.Item valuePropName={'document'} name="document">
                        <Upload {...props}>
                          <Button>Загрузка файлов</Button>
                        </Upload>
                      </Form.Item> */}
                      </div>
                    </Form>
                  </div>
                </div>
              ) : null}
              {/* ////////////////////////////////////////////////////////////// */}
            </Tabs.TabPane>
            {/* В РАЗРАБОТКЕ ###################################*/}
            {/* Поключаем настройки группового чата */}
            {/* {sessionNumber.is_group ? (
              <TabPane tab="Настройки" key="Settings">
                {nameFriend}
                <GroupSettings
                  props={{
                    groupCreateData: groupCreateData,
                    usersArrayFunc: usersArrayFunc,
                    sessionNumber: sessionNumber,
                    usersInGroupChat: usersInGroupChat,
                  }}
                />
              </TabPane>
            ) : null} */}
            {/* ................................... */}
            {/* ################################################# */}
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default React.memo(MainBlockChat);
